<script>
    import hasSelectedProducts from '@/online_booking/new/mixins/hasSelectedProducts.js';
    import sortBy from 'lodash/sortBy';
    import Card from '@/online_booking/new/components/common/Card';
    import { mapActions, mapGetters, mapState } from 'vuex';
    import PreviousButton from '@/online_booking/new/components/common/PreviousButton';
    import StepCounter from '@/online_booking/new/components/common/StepCounter';
    import { bookingKeys } from '@/online_booking/new/helpers/constants';

    export default {
        mixins: [hasSelectedProducts],

        data() {
            return {
                active: false,
                active_done: false,
                first_step: false,
                user: null,
                loading: false,
                currentGroupIndex: null,
                maxOpenCount: 10
            }
        },

        beforeUnmount() {
            this.$event_bus.$off('LoadData');
            this.$event_bus.$off('booking-restart');
            this.$event_bus.$off('ProductsShowed');
            this.$event_bus.$off('CalendarsShowed');
        },

        mounted() {
            let vm = this;

            this.$event_bus.$on('LoadData', (data) => {
                this.user = data.user;
                this.first_step = (data.online_booking_settings.first_step == 'products');
                this.restart();
            });

            this.$event_bus.$on('productsChosenGoToAddons', () => {
                this.active = true;
                this.showAddonProducts();
            });


            this.$event_bus.$on('booking-restart', () => {
                this.restart();
            });

            this.$event_bus.$on('CalendarsShowed', () => {
                if (!this.first_step) {
                    this.restart();
                }
            });

            this.$event_bus.$on('ProductsShowed', () => {
                this.active = false;
                this.active_done = false;
            });

            // copied in watcher

            // not used

            this.$event_bus.$on('ProductsShowed', () => {
                this.restart();

                if (this.first_step) {
                    this.calendar = null;
                }
            });
        },

        methods: {
            ...mapActions('OnlineBooking', ['setCurrentStep', 'setSelectedValue']),
            showAddonProducts() {
                this.active_done = false;
                this.active = true;
                this.setCurrentStep('addonProducts');
            },

            restart() {
                this.active = false;
                this.active_done = false;
                this.$store.commit('clearAddonProducts');
                this.product = null;
                $('#collapseAddonProducts').collapse('hide');
            },

            addonClicked({ product, addon }) {
                this.$store.commit('toggleAddonProductSelection', { product, addon });
            },

            continueToNextStep() {
                $('#collapseAddonProducts').collapse('hide');
                this.active_done = true;
                this.$event_bus.$emit('productsChosen');
            },

            isAddonProductSelected({ product, addon }) {
                return this.$store.getters.hasSelectedAddonProduct({ product, addon });
            },

            getAvailableAddonsForProduct(product) {
                let availableAddons = (product.product ? product.product.addons : product.addons).filter(addon => addon.available_online_book);

                return sortBy(availableAddons, 'name');
            },

            addonProductGroupClicked(index) {
                if (this.currentGroupIndex === index) {
                    this.currentGroupIndex = null;
                } else {
                    this.currentGroupIndex = index;
                }
            },

            groupClasses (index) {
                if (this.selectedProductsWithAddons.length <= this.maxOpenCount || this.currentGroupIndex === index) {
                    return 'max-h-full opacity-1'
                } else {
                    return 'max-h-0 opacity-0'
                }
            },
        },

        computed: {
            ...mapState('OnlineBooking', ['currentStep']),
            ...mapGetters('OnlineBooking', ['getPreviousStepId', 'currentStepNumber', 'totalStepCount']),

            selectedAddonProductNames() {
                if (this.selectedAddonProducts.length > 0) {
                    return this.selectedAddonProducts.map(addon => addon.name).join(', ');
                } else {
                    return trans('online_booking.no_addons_selected');
                }
            },

            isAddonProductStepActive () {
                return this.currentStep === 'addonProducts';
            },
        },

        watch: {
            isAddonProductStepActive (newValue) {
                if (newValue) {
                    this.active_done = false;
                    this.$event_bus.$emit('AddonProductsShowed');
                    window.location.hash = 'choose-addon';
                }
            },

            selectedAddonProductNames (newValue) {
                if (newValue === this.trans('online_booking.no_addons_selected')) {
                    newValue = ''
                }

                this.setSelectedValue({
                    key: bookingKeys.ADDON_PRODUCTS,
                    value: newValue,
                });
            },
        },

        components: {
            StepCounter,
            Card,
            PreviousButton,
        },
    };

</script>

<template>
    <div class="addon-products-container" v-if="isAddonProductStepActive">
        <card class="p-0 overflow-hidden rounded-lg" id="choose-addon-product-panel">
            <h4 class="section-title">
                <step-counter :current="currentStepNumber" :total="totalStepCount" />
                {{ trans('products.choose_addon') }}
            </h4>
            <div
                id="collapseAddonProducts"
                role="tabpanel"
                aria-labelledby="headingAddonProducts"
                data-parent="#booking-accordion"
                class="pt-6"
            >
                <div
                    class="panel-body p-0"
                    id="addon-products-accordion"
                    role="tablist"
                    aria-multiselectable="false"
                >
                    <div
                        v-for="(product, index) in selectedProducts"
                        :key="index"
                        class="panel no-box-shadow"
                    >
                        <div v-if="getAvailableAddonsForProduct(product).length > 0">
                            <a
                                v-if="selectedProductsWithAddons.length > maxOpenCount"
                                :id="'headingProductAddon' + index"
                                class="truncate list-group-item list-group-item-group"
                                role="button"
                                aria-expanded="false"
                                :aria-controls="'collapseProduct' + index"
                                data-parent="#addon-products-accordion"
                                @click="addonProductGroupClicked(index)"
                            >
                                <i class="zmdi zmdi-chevron-right mr-4" v-show="currentGroupIndex !== index"></i>
                                <i class="zmdi zmdi-chevron-down mr-4" v-show="currentGroupIndex === index"></i>
                                <strong>{{ product.product ? product.product.name : product.name }}</strong>
                                {{ trans('online_booking.addon_products_list_heading') }}
                            </a>

                            <div
                                v-else
                                :id="'headingProductAddon' + index"
                                class="truncate cursor-default px-6 py-5"
                                aria-expanded="true"
                                :aria-controls="'collapseProduct' + index"
                                data-parent="#addon-products-accordion"
                            >
                                <strong>{{ product.product ? product.product.name : product.name }}</strong>
                                {{ trans('online_booking.addon_products_list_heading') }}
                            </div>



                            <div
                                :id="'collapseAddonProduct' + index"
                                class="transition-all duration-75 overflow-hidden"
                                :class="groupClasses(index)"
                            >
                                <a
                                    v-for="(addon, addon_index) in getAvailableAddonsForProduct(product)"
                                    class="list-group-item add-on-link"
                                    @click="addonClicked({ product, addon })"
                                    :key="index + ':' + addon_index"
                                    :class="{'selected-product' : isAddonProductSelected({ product, addon })}"
                                >
                                    <span><i class="zmdi zmdi-check selected"></i></span>
                                    <div class="flex flex-column gap-y-2 flex-wrap">
                                        <h5 class="mt-0 mb-0" itemprop="name">
                                            {{ addon.name }}
                                        </h5>
                                        <div class="product-info mt-2">
                                            <span v-if="addon.time !== '0'"><i class="fa-regular fa-clock w-auto"></i> {{ addon.time_formatted }}</span>
                                            <span itemprop="offers"  v-if="addon.price > 0">
                                                <span itemprop="price" :content="addon.price_in_cents_with_vat / 100" />
                                                <span itemprop="priceCurrency" :content="addon.currency" />
                                                <span v-if="addon.time !== '0'">&#183;</span>
                                                {{ addon.price_formatted_with_vat }}

                                            <!-- The addon payment will depend on the parent product settings, hence the use of product.online_payment here -->
                                                <span v-if="(product.online_payment == 1 || (product.product && product.product.online_payment == 1)) && user.is_online_payment_active && user.can_receive_online_payments">
                                                    <span class="label label-info bg-brand-secondary text-brand-primary ml-2">{{ trans('online_payment.must_be_payed') }}</span>
                                                </span>
                                            </span>
                                        </div>
                                    </div>

                                    <div class="row white-background">
                                        <div class="col-xs-12">
                                            <div
                                                class="text-muted m-t-5"
                                                itemprop="description"
                                                v-if="addon.description_formatted !== ''"
                                                v-sanitize-html="addon.description_formatted"
                                            ></div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <transition name="open-addon-summary">
                        <div v-if="hasSelectedAddonProducts" id="addon-products-summary">
                            <div class="p-6">
                                <div class="row products-summary-box m-b-10">
                                    <div class="col-sm-7">
                                        <h4 class="m-t-0">{{ trans('online_booking.selected_addons') }}</h4>
                                        <span v-if="hasSelectedAddonProducts" id="selected-products">
                                        <span v-for="product in selectedProducts" :key="product.id">
                                            <span v-for="(addon, index) in product.selectedAddons" :key="product.id + '::' + index">
                                                <span class="product-heading">
                                                    <span>{{ addon.name }}</span>
                                                    <a @click="addonClicked({ product, addon })" class="flex items-center n-color-text-weak">
                                                        <i class="fa-regular fa-close"></i>
                                                    </a>
                                                </span>
                                            </span>
                                        </span>
                                    </span>
                                    </div>
                                    <div class="text-right hidden-xs m-t-10" v-if="totalAddonProductsDurationInMinutes" :class="{'col-sm-3': totalAddonProductsPrice, 'col-sm-5': !totalAddonProductsPrice}">
                                        <h5 class="m-t-0">{{ trans('global.duration') }}</h5>
                                        <span>+ {{ totalAddonProductsDurationFormatted }}</span>
                                    </div>
                                    <div class="col-sm-2 hidden-xs text-right m-t-10" v-if="totalAddonProductsPrice" :class="{'col-sm-offset-3': !totalAddonProductsDurationInMinutes}">
                                        <h5 class="m-t-0">{{ trans('global.price') }}</h5>
                                        <span>+ {{ totalAddonProductsPriceFormatted }}</span>
                                    </div>
                                    <div class="col-xs-12 hidden-sm hidden-md hidden-lg text-center m-t-10">
                                        <span style="color: #555;"><i class="zmdi zmdi-time"></i> {{ totalAddonProductsDurationFormatted }} · {{ totalAddonProductsPriceFormatted }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
            <div class="signup-buttons flex justify-between flex-wrap gap-6 p-6">
                <previous-button :previous-step-id="getPreviousStepId" />
                <button
                    class="btn btn-custom sm:w-auto"
                    @click="continueToNextStep()"
                >
                    <span class="hidden md:inline">
                        {{ hasSelectedAddonProducts ? trans('online_booking.continue_with_addons') : trans('online_booking.continue_without_addons')}}
                    </span>
                    <span class="md:hidden">
                        <!-- showing a continue button on mobile always -->
                        {{ trans('online_booking.continue_with_addons') }}
                    </span>
                    <i class="zmdi zmdi-arrow-right ml-3"></i>
                </button>
            </div>
        </card>
    </div>
</template>


<style lang="scss" scoped>
.label {
    vertical-align: 1px;
}
</style>
